import React from 'react';

const PaperHeader = ({
        title, 
        classes=[],
        children
    }) => {
        return (
            <div className={`paper-element-heading ${classes.join(" ")}`}>
                <h1 className="paper-element-title">{title}</h1>
                {children}
            </div>
        );
    }

export default PaperHeader;
